import { isEqual } from 'lodash-es'
import * as yup from 'yup'

import { ActivityLocation } from './MovingContractModels'

class LocationSummary {
  _id?: string
  normalizedStreetAddress = ''
  driveDistance = '0 mi'
  driveTime = '0 min'
}

export interface ILocationSummaryProps {
  summaries: LocationSummary[]
  current: LocationSummary
}

class LocationDetails extends ActivityLocation {}

export const LocationTypesOfWork = {
  NOTSPECIFIED: '',
  LOAD: 'Load',
  UNLOAD: 'Unload',
  LOADANDUNLOAD: 'LoadAndUnload',
  HOLD: 'Hold',
  PACKING: 'Packing',
}

const LocationDetailsSchema = yup.object().shape({
  normalizedStreetAddress: yup.string().required('This field is required'),
  typeOfWOrk: yup.string().required('This field is required'),
  bedrooms: yup.string().when('locationType', {
    is: (val: any) => {
      return isEqual(val, 'Apartment') || isEqual(val, 'Condo') || isEqual(val, 'Town-home')
    },
    then: (schema: any) => schema.required('You have chosen a location type that requires the number of bedrooms'),
  }),
  stories: yup.string().when('locationType', {
    is: (val: any) => {
      return isEqual(val, 'House') || isEqual(val, 'Town-home')
    },
    then: (schema: any) => schema.required('You have chosen a location type that requires the number of stories'),
  }),
  sqft: yup.string().when('locationType', {
    is: (val: any) => {
      return isEqual(val, 'House') || isEqual(val, 'Condo') || isEqual(val, 'Town-home')
    },
    then: (schema: any) => schema.required('You have chosen a location type that requires square footage'),
  }),
  dimensions: yup.string().when('locationType', {
    is: (val: any) => {
      return isEqual(val, 'Storage') || isEqual(val, 'Pod') || isEqual(val, 'Rental Truck')
    },
    then: (schema: any) => schema.required('You have chosen a location type that requires dimensions'),
  }),
})

export { LocationDetails, LocationDetailsSchema, LocationSummary }
